import { render, staticRenderFns } from "./ExemptionEdit.vue?vue&type=template&id=a9ff5230&"
import script from "./ExemptionEdit.vue?vue&type=script&lang=js&"
export * from "./ExemptionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports